import * as React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import withQueryParams, { InjectedQueryParams } from 'react-router-query-params'

import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from 'src/store'
import { Point } from 'src/lib/interfaces/point'
import { AccidentListResponse } from 'src/lib/api/accidents'
import { Accident } from 'src/lib/interfaces/Accident.interface'
import { AccidentFilterParameters } from 'src/lib/interfaces/AccidentFilterParameters.interface'
import { AccidentSummary as AccidentSummaryInterface } from 'src/lib/interfaces/AccidentSummary'

import Breadcrumbs from '../Breadcrumbs.component'
import AccidentTable from './components/AccidentTable.components'
import AccidentFilter from './components/AccidentFilter.component'
import AccidentSummary from './components/AccidentSummary.component'
import AccidentHistogram from './components/AccidentHistogram.component'

import { User, hasPermission } from '../../lib/interfaces/User.interface'

import * as accidentsActions from '../../store/accidents/actions'

import { numberArrayDefaultValue } from '../../utils/query-params'

const moment = require('moment')

const castArray = require('lodash/castArray')

export interface AccidentListState {
  pageStatus: 'loading' | 'done'
  systemMigrationNoticeOpen: boolean
}

export interface AccidentListProps extends InjectedQueryParams<AccidentFilterParameters> {
  user: User
  histogramData?: Point[]
  isFetchingSummary: boolean
  accidentFetchFailed: boolean
  isFetchingAccidents: boolean
  fetchAccidentTypes: () => void
  fetchAccidentStatus: () => void
  accidents?: AccidentListResponse
  filterParams: AccidentFilterParameters
  summaryData?: AccidentSummaryInterface
  setCurrentAccident: (accident: Accident) => void
  updateFilterParams: (filterParams: AccidentFilterParameters, next?: () => void) => void
}

class AccidentListPage extends React.PureComponent<AccidentListProps, AccidentListState> {
  state: AccidentListState = {
    pageStatus: 'loading',
    systemMigrationNoticeOpen: true
  }

  componentDidMount() {
    const { queryParams, updateFilterParams, fetchAccidentTypes, fetchAccidentStatus } = this.props

    fetchAccidentTypes()
    fetchAccidentStatus()

    updateFilterParams(queryParams)
  }

  componentDidUpdate(prevProps: AccidentListProps) {
    if (this.props.accidents) {
      this.setState(() => ({ pageStatus: 'done' }))
    }
  }

  onFiltersChange = (filters: AccidentFilterParameters) => {
    this.props.updateFilterParams(filters)
    this.props.setQueryParams(filters)
  }

  render() {
    const { systemMigrationNoticeOpen } = this.state
    const { user, accidents, queryParams, isFetchingSummary } = this.props

    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Accidents', active: true }
        ]} />

        <div className="page">          
          <div className="d-flex align-items-center mb-2">
            <h5 className="title mb-0">Accidents</h5>
            {hasPermission(user, 'ROLE_ACCIDENT_ADMIN') &&
              <Link to="/accidents/report">
                <Button className="ggbutton btn-sm btn-dark ml-3">Add Accident</Button>
              </Link>
            }
            <Link to="/documentation/accident">
              <Button className="ggbutton btn-sm btn-outline-info ml-3">Documentation</Button>
            </Link>
          </div>

          <AccidentSummary isLoading={isFetchingSummary} data={this.props.summaryData!} />
          <br/>
          {/* {this.props.histogramData && <AccidentHistogram className="mb-3" data={this.props.histogramData!} />} */}
          <AccidentFilter filterParams={queryParams} onChange={this.onFiltersChange} />

          {accidents && <AccidentTable accidents={accidents} onSelect={this.props.setCurrentAccident} loadingFailed={this.props.accidentFetchFailed} isLoading={this.props.isFetchingAccidents} />}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState)  => ({
  user: state.auth.user,
  accidents: state.accidents.accidents,
  summaryData: state.accidents.summaryData,
  filterParams: state.accidents.filterParams,
  histogramData: state.accidents.histogramData,
  isFetchingSummary: state.accidents.isFetchingSummary,
  accidentFetchFailed: state.accidents.accidentFetchFailed,
  isFetchingAccidents: state.accidents.isFetchingAccidents
})

const mapDispatchToProps = (dispatch) => ({
  fetchAccidentTypes: () => dispatch(accidentsActions.fetchAccidentTypesDispatchCommand()),
  fetchAccidentStatus: () => dispatch(accidentsActions.fetchAccidentStatusDispatchCommand()),
  setCurrentAccident: (accident: Accident) => dispatch(accidentsActions.setCurrentAccident(accident)),
  updateFilterParams: (filterParams: AccidentFilterParameters, next?: () => void) =>
    dispatch(accidentsActions.updateAccidentFilterParamsDispatchCommand(filterParams, next))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withQueryParams<AccidentFilterParameters, AccidentListProps>({
    stripUnknownKeys: true,
    keys: {
      accidentStatus: {
        validate: () => false,
        default: (value, props) => {
          if (value) { return numberArrayDefaultValue(value) }
          return props.filterParams.accidentStatus
        }
      },
      accidentTypes: {
        validate: () => false,
        default: (value, props) => {
          if (value) { return numberArrayDefaultValue(value) }
          return props.filterParams.accidentTypes
        }
      },
      managerApproval: {
        validate: () => false,
        default: (value, props) => {
          if (value) { return castArray(value) }
          return props.filterParams.managerApproval
        }
      },
      locationPosition: {
        validate: () => false,
        default: (value, props) => {
          if (value) { return numberArrayDefaultValue(value) }
          return props.filterParams.locationPosition
        }
      },
      lossDateFrom: {
        default: (value, props) => props.filterParams.lossDateFrom,
        validate: value => {
          if (!value) { return false }
          return moment(value).isValid()
        }
      },
      lossDateTo: {
        default: (value, props) => props.filterParams.lossDateTo,
        validate: value => {
          if (!value) { return false }
          return moment(value).isValid()
        },
      },
      location: {
        validate: () => false,
        default: (value, props) => {
          if (value) {
            return numberArrayDefaultValue(value)
          }

          return props.filterParams.location
        }
      }
    }
  }
)(AccidentListPage))



// WEBPACK FOOTER //
// ./src/routes/accidents/AccidentList.page.tsx